import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistKO() {
  const articleData = {
    title: '당신의 전 애인은 내현적 나르시시스트입니까? (텍스트는 거짓말을 하지 않습니다)',
    description: '전 애인이 내현적 나르시시스트인지 궁금하십니까? 저희 AI가 문자 메시지에서 즉시 감지하는 7가지 미묘한 조작 행동을 발견하세요.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector 편집팀'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '내현적 나르시시스트란 무엇이며 외현적 나르시시스트와 어떻게 다릅니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '내현적 나르시시스트는 명백하고 외현적인 나르시시스트와 달리 매력, 미묘한 감정적 전술, 수동적 공격적인 메시지 뒤에 조작적인 행동을 숨깁니다.'
      }
    }, {
      '@type': 'Question',
      name: 'AI가 문자 메시지에서 내현적 나르시시즘을 감지할 수 있습니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '네. Toxic Detector는 어조, 죄책감 유발, 러브 바밍 주기, 불일치 및 정서적 조작 패턴을 분석하여 내현적 나르시시스트 행동을 표시합니다.'
      }
    }, {
      '@type': 'Question',
      name: '텍스트에서 내현적 나르시시스트의 일반적인 행동은 무엇입니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '정서적 조작, 가스라이팅, 수동적 공격적인 댓글, 피해자 코스프레, 러브 바밍 후 철수, 미묘한 통제 등입니다.'
      }
    }, {
      '@type': 'Question',
      name: '내현적 나르시시스트로부터 자신을 보호하려면 어떻게 해야 합니까?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '메시지를 기록하고, 직감을 믿고, 경계를 유지하고, Toxic Detector와 같은 도구를 사용하여 조작적인 패턴을 객관적으로 식별하십시오.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/ko/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('링크가 클립보드에 복사되었습니다!');
    }
  };
  return <>
      <MetaTags title="당신의 전 애인은 내현적 나르시시스트입니까? AI가 조작을 감지하는 방법 | ToxicDetector" description="전 애인이 내현적 나르시시스트인지 궁금하십니까? 저희 AI가 즉시 감지하는 7가지 미묘한 조작 행동을 발견하세요." keywords="내현적 나르시시스트 징후, 숨겨진 나르시시스트 행동, 나르시시스트 조작 텍스트, AI 나르시시스트 탐지기" canonical={`https://toxicdetector.com/ko/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-8150" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8151">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-8152">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-8153">
            <div className="flex items-center justify-between" data-id="element-8154">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-8155">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="기사 공유" data-id="element-8156">
                <Share2 size={20} className="text-gray-600" data-id="element-8157" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-8158">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-8159">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8160" />
            블로그로 돌아가기
          </Link>

          <header className="mb-12" data-id="element-8161">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-8162">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-8163">
              <time dateTime={articleData.publishDate} data-id="element-8164">
                {new Date(articleData.publishDate).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8165">•</span>
              <span data-id="element-8166">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-8167">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="AI를 사용하여 내현적 나르시시스트 조작 징후에 대해 문자 메시지를 분석하는 여성" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-8168" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-8169">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-8170">목차</h2>
            <ul className="space-y-3 text-sm" data-id="element-8171">
              <li data-id="element-8172">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8173">
                  <span className="text-gray-400" data-id="element-8174">→</span> 1. 모든 메시지에서의
                  정서적 조작
                </a>
              </li>
              <li data-id="element-8175">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8176">
                  <span className="text-gray-400" data-id="element-8177">→</span> 2. 서서히 구축되는
                  가스라이팅
                </a>
              </li>
              <li data-id="element-8178">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8179">
                  <span className="text-gray-400" data-id="element-8180">→</span> 3. 수동적 공격적인
                  댓글
                </a>
              </li>
              <li data-id="element-8181">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8182">
                  <span className="text-gray-400" data-id="element-8183">→</span> 4. 끊임없이 피해자
                  코스프레
                </a>
              </li>
              <li data-id="element-8184">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8185">
                  <span className="text-gray-400" data-id="element-8186">→</span> 5. 러브 바밍 후 철수
                </a>
              </li>
              <li data-id="element-8187">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8188">
                  <span className="text-gray-400" data-id="element-8189">→</span> 6. 숨겨진 통제 및
                  감시
                </a>
              </li>
              <li data-id="element-8190">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8191">
                  <span className="text-gray-400" data-id="element-8192">→</span> 7. 채널 간 일관성
                  없는 어조
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8193">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-8194">
              전 애인이 매력적이고 배려심 깊은 척하면서 뒤에서 당신을 조작하고
              있다고 느낀 적이 있나요? 그것은{' '}
              <strong data-id="element-8195">내현적 나르시시스트의 전형적인 징후</strong>입니다. 명백한
              나르시시스트와 달리, 내현적 나르시시스트는 미묘한 감정적 전술 뒤에
              조작을 숨깁니다.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-8196">
              저희 <strong data-id="element-8197">AI는 숨겨진 조작을 감지</strong>하고 텍스트를
              분석하는 것만으로 즉시 식별합니다. 방법은 다음과 같습니다.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-8198">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8199">
                1️⃣ 모든 메시지에서의 정서적 조작
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8200">
                내현적 나르시시스트는 자신의 뜻대로 하기 위해 감정을 비드립니다.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8201">
                <p className="italic text-gray-700 text-lg" data-id="element-8202">
                  "네가 이것 때문에 화를 내다니 믿을 수가 없어..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8203">
                AI는 일상적인 메시지에 숨겨진 미묘한 죄책감 유발과 정서적 압박을
                감지합니다.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-8204">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8205">
                2️⃣ 서서히 구축되는 가스라이팅
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8206">
                <p className="italic text-gray-700 text-lg" data-id="element-8207">
                  "넌 그걸 잘못 기억하고 있어..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8208">
                내현적 나르시시스트는 당신이 자신의 기억을 의심하게 만듭니다.
                AI는 현실이 왜곡되는 반복적인 사례를 표시합니다.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-8209">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8210">
                3️⃣ 수동적 공격적인 댓글
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8211">
                <p className="italic text-gray-700 text-lg" data-id="element-8212">
                  "그래, 네가 행복하다면 뭐든..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8213">
                수동적 공격성은 내현적 나르시시즘의 특징입니다. AI는 비꼬는 말,
                은밀한 비방, 숨겨진 적대감을 인식합니다.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-8214">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8215">
                4️⃣ 끊임없이 피해자 코스프레
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8216">
                <p className="italic text-gray-700 text-lg" data-id="element-8217">
                  "내가 널 위해 한 모든 것에도 불구하고..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8218">
                내현적 나르시시스트는 종종 비난을 뒤집어 자신을 피해자로
                만듭니다. AI는 당신에게 죄책감을 느끼게 하거나 사과를 강요하도록
                고안된 문구를 감지합니다.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-8219">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8220">
                5️⃣ 러브 바밍 후 철수
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8221">
                <p className="italic text-gray-700 text-lg" data-id="element-8222">
                  "넌 내가 사랑한 유일한 사람이야 😢" → 잠수
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8223">
                강렬한 애정 표현 후 정서적 거리를 두는 이 고전적인 주기는 위험
                신호입니다. AI는 여러 채팅에 걸쳐 이러한 패턴을 식별합니다.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-8224">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8225">
                6️⃣ 숨겨진 통제 및 감시
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8226">
                <p className="italic text-gray-700 text-lg" data-id="element-8227">
                  "그냥 확인하는 거야... 또"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8228">
                관심으로 가장한 미묘한 통제는 은밀한 전술입니다. AI는 명백한
                공격성 없이 반복적인 확인 행동을 표시합니다.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-8229">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8230">
                7️⃣ 채널 간 일관성 없는 어조
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8231">
                <p className="italic text-gray-700 text-lg" data-id="element-8232">
                  단체 채팅: 장난기 / 1:1: 비판적
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8233">
                내현적 나르시시스트는 종종 공개적으로는 행동을 숨기고 사적으로는
                조작합니다. AI는 대화를 비교하여 불일치를 강조합니다.
              </p>
            </section>

            <section className="mb-12" data-id="element-8234">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8235">
                🛡 자신을 보호하는 방법
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-8236">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-8237">
                  <li className="flex items-start gap-3" data-id="element-8238">
                    <span className="text-purple-600 font-bold" data-id="element-8239">•</span>
                    <span data-id="element-8240">직감을 믿으세요. 위험 신호를 무시하지 마세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8241">
                    <span className="text-purple-600 font-bold" data-id="element-8242">•</span>
                    <span data-id="element-8243">명확성을 위해 스크린샷을 보관하세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8244">
                    <span className="text-purple-600 font-bold" data-id="element-8245">•</span>
                    <span data-id="element-8246">친구 나 치료사와 경험을 공유하세요.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8247">
                    <span className="text-purple-600 font-bold" data-id="element-8248">•</span>
                    <span data-id="element-8249">
                      Toxic Detector와 같은 도구를 사용하여 패턴을 식별하세요.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-8250">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8251">
                💀 자신의 눈으로 확인하세요
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8252">
                내현적 나르시시즘은 발견하기 어려울 수 있지만 AI는 놓치지
                않습니다. 채팅을 업로드하고 즉시 분석을 받으세요:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-8253">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-8254">
                  "🚩 78% 조작 감지. 은밀한 전술 식별됨!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-8255">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8256">
                자주 묻는 질문
              </h2>
              <div className="space-y-4" data-id="element-8257">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-8258">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-8259">
                      <span data-id="element-8260">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-8261" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-8262">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-8263">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-8264">
              💀 진실을 밝힐 준비가 되셨나요?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-8265">
              추측은 그만하세요. 텍스트를 Toxic Detector에 업로드하고 즉시 독성
              점수를 받으세요. 저희 AI는 당신이 놓쳤을지도 모르는 은밀한 조작을
              드러냅니다.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-8266">
              <p className="font-bold text-xl" data-id="element-8267">
                "🚩 78% 조작 감지. 은밀한 전술 식별됨!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-8268">
              지금 채팅 스캔하기 →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'AI가 즉시 감지하는 가스라이팅 징후 7가지',
          description: 'AI가 텍스트 대화에서 감지하는 주요 가스라이팅 패턴을 알아보세요.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: '수동적 공격적인 텍스트에 대한 궁극적인 가이드',
          description: '문자 메시지에서 수동적 공격적인 행동과 숨겨진 조작을 발견하세요.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-8269" />

          <div className="mt-12 text-center" data-id="element-8270">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-8271">
              <Share2 size={18} className="mr-2" data-id="element-8272" />이 기사 공유하기
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-8273">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-8274">
            <p className="text-gray-500 text-sm" data-id="element-8275">
              © {new Date().getFullYear()} ToxicDetector. 판권 소유.
            </p>
          </div>
        </footer>
      </div>
    </>;
}